export function isIpad(){
    return navigator.userAgent.match(/iPad/i) != null || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export function isSafari(){
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)|| window.safari;
}

export function isFirefox(){
    return (navigator.userAgent.toLowerCase().indexOf("firefox") !== -1);
}